import React from 'react';

const Apps = () => {
  return (
    <div className="apps-container" style={{textAlign:"center", color:"#666", marginTop:"4rem"}}>
        <h1>Apps</h1>
        <p>No active apps. Explore the app store.</p>
    </div>
  );
};

export default Apps;
